var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","fill":"none","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"stroke":"var(--v-grey-darken-1)","stroke-linecap":"round","stroke-width":"2","d":"M21 3 3 21"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }